import { z } from "zod";

export const audioTrackSchema = z.object({
  position: z.string().min(1),
  file: z.instanceof(File),
});

export const audioTracksSchema = z.object({
  book: z.number(),
  tracks: z.array(audioTrackSchema).min(1),
});

export type AudioTrackFormValue = z.infer<typeof audioTrackSchema>;
export type AudioTracksFormValues = z.infer<typeof audioTracksSchema>;
